"use strict";

/**
 * @classdesc
 * Container zur Verwaltung der layerbasierten Abfrage-Ergebnisse.
 *
 * @class
 * @memberof gc.gis.module.GCFeatureInfo
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 */
gc.gis.module.GCFeatureInfo.LayerResultList = function(feature_container_class, options)
{
    gc.gis.widget.GCWidget.call(this, {
        className: 'gc-featureinfo-layerlist'
    });

    this._feature_container_class = feature_container_class;
    this._max_features = options.maxFeatures;

    /**
     * Container für das Accordion der Layer
     * @type {gc.gis.widget.GCAccordion}
     * @private
     */
    this._layer_container = null;
    /**
     * Liste der Layer
     * @type {gc.gis.layer.GCAbstractLayer[]}
     * @private
     */
    this._layers = [];
    /**
     * Liste der Container, welche die Features pro Layer aufnehmen (Indizierung passt zur Liste der Layer)
     * @type {gc.gis.module.GCFeatureInfo.AbstractFeatureResultList[]}
     * @private
     */
    this._feature_containers = [];

    // Elemente erzeugen und Hauptcontainer initialisieren
    this._render();
};
gc.gis.module.GCFeatureInfo.LayerResultList.prototype = Object.create(gc.gis.widget.GCWidget.prototype);

/**
 * @inheritDoc
 */
gc.gis.module.GCFeatureInfo.LayerResultList.prototype._render = function()
{
    this._layer_container = new gc.gis.widget.GCAccordion({
        className: this.className
    });

    return this._layer_container.getElement();
};

/**
 * Fügt einen Layer dem Container hinzu.
 *
 * @method
 * @param {gc.gis.layer.GCAbstractLayer} layer abzufragender Layer
 * @public
 */
gc.gis.module.GCFeatureInfo.LayerResultList.prototype.addLayer = function(layer)
{
    // ggf. Layer-Item erzeugen
    if (!this._getLayerItem(layer))
    {
        this._createLayerItem(layer);
    }
};

/**
 * Prüft, ob der dem Layer zugehörige Container aktiv (geöffnet) ist.
 *
 * @method
 * @param {gc.gis.layer.GCAbstractLayer} layer abzufragender Layer
 * @return boolean
 * @public
 */
gc.gis.module.GCFeatureInfo.LayerResultList.prototype.isLayerActive = function(layer)
{
    return this._layer_container.isItemOpen(this._getLayerIndex(layer));

};

/**
 * Liefert die Anzahl der Features zum angegeben Layer.
 *
 * @method
 * @return {int}
 * @public
 */
gc.gis.module.GCFeatureInfo.LayerResultList.prototype.numFeatures = function(layer)
{
    var container = this.getFeatureContainer(layer);
    if (container) {
        return container.numFeatures();
    }

    return 0;
};

/**
 * Fügt eine Liste von Features dem Container hinzu.
 *
 * @method
 * @param {gc.gis.layer.GCAbstractLayer} layer abzufragender Layer
 * @param {gc.gis.feature.GCFeature|gc.gis.feature.GCFeature[]} features
 * @public
 */
gc.gis.module.GCFeatureInfo.LayerResultList.prototype.addFeatures = function(layer, features)
{
    var feature_container = this.getFeatureContainer(layer);
    if (feature_container)
    {
        if (!Array.isArray(features)) {
            feature_container.addFeature(layer, features);
        }
        else {
            feature_container.addFeatures(layer, features);
        }

        var badge = feature_container.numFeatures();
        if (badge >= this._max_features) {
            badge += ' !';
        }
        this._layer_container.setItemBadge(
            this._getLayerIndex(layer),
            badge.toString()
        );
    }
};

/**
 * Liefert den Feature-Container für einen Layer.
 *
 * @method
 * @param {gc.gis.layer.GCAbstractLayer} layer
 * @return {gc.gis.module.GCFeatureInfo.AbstractFeatureResultList|null}
 * @public
 */
gc.gis.module.GCFeatureInfo.LayerResultList.prototype.getFeatureContainer = function(layer)
{
    var index = this._getLayerIndex(layer);
    if (index >= 0 && index < this._feature_containers.length) {
        return this._feature_containers[index];
    }

    return null;
};

/**
 * Leert den Inhalt des Containers.
 *
 * @method
 * @public
 */
gc.gis.module.GCFeatureInfo.LayerResultList.prototype.clear = function()
{
    this._layer_container.clear();
    this._layers = [];
    this._feature_containers = [];
};

/**
 * Gibt für einen Layer den korrespondierenden Index innerhalb der Ergebnisliste zurück oder <code>-1</code> sofern
 * kein passender Eintrag existiert.
 *
 * @method
 * @return {int} Index des Layers in der Ergebnisliste
 * @protected
 */
gc.gis.module.GCFeatureInfo.LayerResultList.prototype._getLayerIndex = function(layer)
{
    for (var i = 0; i < this._layers.length; i++) {
        if (this._layers[i] === layer) {
            return i;
        }
    }
};

/**
 * Gibt für einen Layer das korrespondierende Element zurück oder <code>null</code> sofern dieses noch nicht existiert.
 *
 * @method
 * @return {jQuery} Layer-Container-Element
 * @protected
 */
gc.gis.module.GCFeatureInfo.LayerResultList.prototype._getLayerItem = function(layer)
{
    return this._layer_container.getItem(this._getLayerIndex(layer));
};

/**
 * Erzeugt für einen Layer ein Eintrag für die Ausgabe des Ergebnis oder liefert einen passenden Eintrag zurück,
 * sofern dieser bereits existiert.
 *
 * @method
 * @param {gc.gis.layer.GCAbstractLayer} layer
 * @return {jQuery} Layer-Element
 * @protected
 */
gc.gis.module.GCFeatureInfo.LayerResultList.prototype._createLayerItem = function(layer)
{
    var self = this;

    var item = this._layer_container.addItem(
        'layer_' + (this._layers.length + 1),
        layer.getLabel(),
        '',
        {
            collapsed: true,
            badge: '0',
            open: function(index) {
                var feature_container = self.getFeatureContainer(layer);
                if (feature_container)
                {
                    self._fireEvent(gc.gis.module.GCFeatureInfoEvent.RESULT_LAYER_OPEN, {
                        layer: layer,
                        features: feature_container.getFeatures()
                    });
                }
            },
            close: function(index) {
                var feature_container = self.getFeatureContainer(layer);
                if (feature_container)
                {
                    self._fireEvent(gc.gis.module.GCFeatureInfoEvent.RESULT_LAYER_CLOSE, {
                        layer: layer,
                        features: feature_container.getFeatures()
                    });
                }
            },
            enter: function(index) {
                var feature_container = self.getFeatureContainer(layer);
                if (feature_container)
                {
                    self._fireEvent(gc.gis.module.GCFeatureInfoEvent.RESULT_LAYER_MOUSEENTER, {
                        layer: layer,
                        features: feature_container.getFeatures()
                    });
                }
            },
            leave: function(index) {
                var feature_container = self.getFeatureContainer(layer);
                if (feature_container)
                {
                    self._fireEvent(gc.gis.module.GCFeatureInfoEvent.RESULT_LAYER_MOUSELEAVE, {
                        layer: layer,
                        features: feature_container.getFeatures()
                    });
                }
            }
        }
    );

    if (item)
    {
        var feature_container = new this._feature_container_class();
        var length = this._layers.push(layer);
        this._feature_containers.push(feature_container);

        // Events delegieren
        feature_container.on(gc.gis.module.GCFeatureInfoEvent.RESULT_FEATURE_OPEN, this, function(evt) {
            self._fireEvent(gc.gis.module.GCFeatureInfoEvent.RESULT_FEATURE_OPEN, evt);
        });
        feature_container.on(gc.gis.module.GCFeatureInfoEvent.RESULT_FEATURE_CLOSE, this, function(evt) {
            self._fireEvent(gc.gis.module.GCFeatureInfoEvent.RESULT_FEATURE_CLOSE, evt);
        });
        feature_container.on(gc.gis.module.GCFeatureInfoEvent.RESULT_FEATURE_MOUSEENTER, this, function(evt) {
            self._fireEvent(gc.gis.module.GCFeatureInfoEvent.RESULT_FEATURE_MOUSEENTER, evt);
        });
        feature_container.on(gc.gis.module.GCFeatureInfoEvent.RESULT_FEATURE_MOUSELEAVE, this, function(evt) {
            self._fireEvent(gc.gis.module.GCFeatureInfoEvent.RESULT_FEATURE_MOUSELEAVE, evt);
        });
        feature_container.on(gc.gis.module.GCFeatureInfoEvent.RESULT_FEATURE_CLICK, this, function(evt) {
            self._fireEvent(gc.gis.module.GCFeatureInfoEvent.RESULT_FEATURE_CLICK, evt);
        });
        feature_container.on(gc.gis.module.GCFeatureInfoEvent.RESULT_FEATURE_ZOOM, this, function(evt) {
            self._fireEvent(gc.gis.module.GCFeatureInfoEvent.RESULT_FEATURE_ZOOM, evt);
        });

        // Feature-Container dem Layer-Item zuweisen
        this._layer_container.setItemContent(length-1, feature_container.getElement());
    }

    return item;
};